import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, putApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, AtualizarParametroLocalidadeRequest } from './types';

// ACTIONS
import {
	atualizarParametroLocalidadeSuccess,
	atualizarParametroLocalidadeFailure,
} from './actions';

function* atualizarParametroLocalidade(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: AtualizarParametroLocalidadeRequest } = request;

	const body = { ...payload };

	delete body.id;

	const response: ApiResponse = yield call(
		putApi,
		token || '',
		PATH_SGU_API,
		`v2/parametros-localidades/${payload.sigla}/localidades`,
		body,
	);

	if (
		response.status === 200 ||
		response.status === 201 ||
		response.status === 204
	) {
		yield put(atualizarParametroLocalidadeSuccess(response));
	} else {
		yield put(atualizarParametroLocalidadeFailure());
	}
}

export default all([
	takeLatest(
		Types.ATUALIZAR_PARAMETRO_LOCALIDADE,
		atualizarParametroLocalidade,
	),
]);
